<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Belastbaar bedrag
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <div id="bldSubContent1">
                    Het belastbaar bedrag is het fiscale resultaat van een vennootschap waarop de vennootschapsbelasting
                    (Vpb) wordt geheven. Dit bedrag vormt de grondslag voor de berekening van de verschuldigde belasting
                    en wordt vastgesteld na correcties op de commerciële winst en toepassing van eventuele fiscale
                    faciliteiten en verliesverrekeningen.
                    <div class="space20"></div>

                    De berekening verloopt in grote lijnen als volgt:<br/>
                    <ol>
                        <li>Commerciële winst: de winst zoals vastgesteld in de jaarrekening.</li>
                        <li>Fiscale correcties: aanpassingen op de commerciële winst op basis van fiscale regels
                            (bijvoorbeeld
                            niet-aftrekbare kosten of fiscale vrijstellingen).
                        </li>
                        <li>Fiscale winst: het resultaat na toepassing van de fiscale correcties.</li>
                        <li>Verliesverrekening: eventuele verrekening van verliezen uit voorgaande jaren of het lopende
                            jaar
                            (voor zover toegestaan).
                        </li>
                        <li>Belastbaar bedrag: de fiscale winst na verrekening van verliezen.</li>
                    </ol>

                    Belang: Het belastbaar bedrag is van essentieel belang, omdat het bepaalt over welk bedrag
                    daadwerkelijk vennootschapsbelasting moet worden betaald. Een lager belastbaar bedrag (bijvoorbeeld
                    door verliesverrekening) leidt tot minder belasting, terwijl een hoger bedrag leidt tot een hogere
                    belastingaanslag.
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="heading2">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                    Verrekenen verlies dit boekjaar met winst voorgaand jaar
                </button>
            </h2>
            <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
                 data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    Een verlies uit een bepaald boekjaar wordt op 2 manieren verrekend:
                    <ul>
                        <li> Met de belastbare winst uit het voorgaande boekjaar. Dit wordt carry back of achterwaartse
                            verliesverrekening genoemd.
                        </li>
                        <li> Met de winsten van volgende boekjaren. Dit wordt carry forward of voorwaartse
                            verliesverrekening
                            genoemd.
                        </li>
                    </ul>
                    <b>Eerst carry back, dan carry forward</b><br/>
                    Een verlies wordt eerst verrekend met de winst van het voorgaande jaar. Pas daarna verrekent u het
                    verlies met de winsten van de toekomstige jaren.
                    <div class="space20"></div>
                    <b>Verlies in dit boekjaar?</b><br/>
                    Vul bij de vraag 'Te verrekenen verlies van dit boekjaar met winst voorgaand jaar'
                    het bedrag in van het verlies van dit boekjaar dat verrekend kan worden met winst van het vorig
                    boekjaar. Uiteraard kun je niet meer verrekenen dan er aan verlies in dit boekjaar is. Een eventueel
                    resterend verlies is verrekenbaar met winsten van volgende boekjaren.

                </div>
            </div>
        </div>
    </div>

</div>
